// Framework and third-party non-ui
import styled from "styled-components";

const StyledModalWrapper = styled.div`
  width: 100%;
  height: 100%;

  position: fixed;
  top: 0;

  display: flex;
  justify-content: center;
  align-items: center;

  z-index: 2;
`;

export default StyledModalWrapper;
